#!/usr/bin/env node
/**
 * Classic Theme MCP CLI
 *
 * Run this to start the MCP server for AI model integration.
 *
 * Usage:
 *   classic-theme-mcp
 *   node dist/cli.js
 */

import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import { createServer } from './server.js';

async function main() {
  const server = createServer();
  const transport = new StdioServerTransport();
  await server.connect(transport);
}

main().catch((error) => {
  console.error('Failed to start MCP server:', error);
  process.exit(1);
});
